import { render, staticRenderFns } from "./ReportConstructor.vue?vue&type=template&id=60fc57e1&"
import script from "./ReportConstructor.vue?vue&type=script&lang=ts&"
export * from "./ReportConstructor.vue?vue&type=script&lang=ts&"
import style0 from "./ReportConstructor.vue?vue&type=style&index=0&id=60fc57e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports